var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturncart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.207,
    height: 12.46,
    viewBox: "0 0 14.207 12.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.207 -0.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M0,1H12",
    transform: "translate(1.5 5.5)",
    fill: "none",
    stroke: "#788995",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    "data-name": "Line",
    d: "M.5,6.5,6.023.977",
    fill: "none",
    stroke: "#788995",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-3",
    "data-name": "Line",
    d: "M.5-6.5,6.023-.977",
    transform: "translate(0 13)",
    fill: "none",
    stroke: "#788995",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturncart);
export default __webpack_public_path__ + "static/media/returncart.13fa9eaff0994e02307251cdb6518578.svg";
export { ForwardRef as ReactComponent };